
  <div class="modal-content modal-content-width" *ngIf="onselect">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
        <div class="row">
          <div class="col-md-8">
            Patient Search
          </div>
          <div class="col-md-4">
            <button type="button" class="close" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
        </div>
        

        

      </div>
     
      <div class="modal-body padding-top-0px counselling-modal">

      
            <div class="row margin-top-10 margin-bottom-10px margin-left-10px">
              <div class="col-md-5">
                <input type="text" class="form-control" placeholder="Search by Name,Gender,Phone Number" (input)="criteriaChange($event.target.value)">
                <!--<search-list [title]="searchTitle" [hideTitle]="1" (change)="criteriaChange($event)"></search-list>-->
              </div>
              
            
              
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="card">
                  <div class="card-body padding-top-0px padding-left-0px padding-right-0px padding-bottom-0px">
                    <div class="table-component">
                      <div class="table-responsive overflow-x">


                        <table class="table table-striped margin-left-zero "
                               cols="auto,2*,*,*,*,*,*,*">

                          <thead class="">
                            <tr>
                              <th></th>
                              <th class="">
                                PID
                              </th>
                              <!--<th class="text-align-center">Day</th>-->

                              <th class="text-align-center">
                                Old Reg No
                              </th>
                              <th class="">
                                Name
                              </th>
                              <!--<th class="text-align-center">Start Time</th>-->
                              <th class="">
                                Reg Date
                              </th>

                              <!--<th class="">
              Prime Relation
            </th>-->

                              <th class="">
                                Contact
                              </th>
                              <th class="">
                                Sex
                              </th>
                              <th class="">Age</th>

                              <th>Marital </th>
                              <th>Category</th>
                             



                            </tr>
                          </thead>

                          <tbody class="table-body">
                            <tr *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                             <td><button type="button" class="btn font-size-13px actions-btn-prime" (click)="ShowCryoadd()">Select</button></td>
                              <td class="td-padding "> <a (click)="ViewPatientDetails(l)" class="nav-link-hand">{{l.FormattedCode}}</a>  </td>
                              <!--<td class="td-padding text-align-center">Mon</td>-->
                              <td class="td-padding text-align-center">

                                {{l.PatientRegistrationNumber}}
                              </td>
                              <td class=" td-padding ">{{l.DisplayName}}</td>
                              <!--<td class="td-padding text-align-center"></td>-->
                              <td class="padding-right-0px padding-left-0px">{{l.RegistrationDate| date:'MMM-dd-yyyy'}}</td>
                              <!--<td class="  ">{{l.PrimeRelation}}</td>-->

                              <td class="">{{l.Telephone1}}</td>
                              <td class=" ">{{l.Gender}}</td>
                              <td class="padding-right-0px padding-left-0px">{{l.Age}}</td>

                              <td>{{l.MaritalStatus}}</td>
                              <td>{{l.PatientCategory}}</td>


                             



                            </tr>

                          </tbody>

                        </table>
                      </div>
                    </div>
                  </div>
                </div>
               
              </div>
            </div>


      </div>
        <div class="modal-footer padding-top-10px padding-bottom-10px">

          <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>
         
        </div>
     
    </div>
  </div>
  <div *ngIf="displyadd">
    <div class="card col-xl-12 col-lg-12 col-md-12 col-sm-12  my-profile-form document">


      <div class="card-header wh-header border-bottom padding-bottom-0px padding-left-15px padding-right-15px">
        <div class="row" >
          <!--<div class="col-md-1 padding-left-0px padding-right-0px">
          <a class="education-navlink addicon-circle">
            <span class="badge">

              <i class="fas fa-user-plus"></i>
            </span>
          </a>
        </div>-->
          <div class="col-md-4 padding-left-9px padding-right-0px">
            <label class="margin-top-3px">Profile</label>
          </div>
          <div class="col-md-6 padding-left-0px">
            Add Cryo Storage
          </div>
          <div class="col-md-2">
            <button type="button" class="close float-right margin-top-4px" data-dismiss="modal"
                    (click)="activeModal.dismiss('Cross click')"
                    aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          
        </div>



      </div>

      <div class="modal-body padding-top-0px counselling-modal">

        <div class="row" >
          <div class="position-fixed-counselling">
            <div class=" card bk-color-light2 card-height">
              <div class="row margin-top-10">
                <div class="offset-md-3 col-md-3 padding-left-0px">
                  <img class="img-circle-50 margin-left-10px" src="dummy.jpg" >
                  <!--<img  class="img-circle-50 margin-left-10px" *ngIf="!l.PatientImageFile" src="dummy.jpg">-->
                </div>
              </div>
              <div class="row">
                <div class="offset-md-2 col-md-8 padding-left-0px padding-right-0px text-align-center">
                  <label class="margin-bottom-0px color5 font-weight-bold font-size-19px margin-bottom-0px">Ramya Santhosh</label>
                </div>
              </div>
              <div class="row">
                <div class="offset-md-3 col-md-7">
                  <label class="margin-bottom-0px">GG1O/843</label>
                </div>
              </div>
              <div class="row">
                <div class="offset-md-3 col-md-8">
                  <label class="margin-bottom-0px">
                    <!--32yrs,Female-->
                    29,Female
                  </label>
                </div>
              </div>
              <div class="row">
                <!--<div class="col-md-3">
                <label>Phone Number:</label>
              </div>-->
                <div class="offset-md-3 col-md-6">
                  9078562145
                </div>
              </div>
            </div>
          </div>
          <div class="offset-md-4 col-md-8">
            
             

                <form class="form " novalidate="" (ngSubmit)="onSubmit()" #f="ngForm">

                  <div class="col-md-12">
                    <div class="row margin-top-10 ">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Storage System Type</label>
                          </div>


                          <div class="col-md-5">
                            <CodeTypeValue CodeType="CNSPN">


                            </CodeTypeValue>

                            <!--<CustomDataByRequestType RequestedType="FacilitiesByActor" ActorCode={{ActorCode}}
                                   id="CurrentSaveCounsellingPlanRequest.BranchCode" SelectedValue=""
                                   [(ngModel)]="CurrentSaveCounsellingPlanRequest.BranchCode" (keyChange)="onAssignedToActorCode($event)"
                                   name="CurrentSaveCounsellingPlanRequest.BranchCode" required>
          </CustomDataByRequestType>-->
                            <!--<label>{{FacilityShortName}}</label>-->
                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row margin-top-10 ">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span> Treatment Cycle</label>
                          </div>


                          <div class="col-md-5">
                            <CodeTypeValue CodeType="CNSPN">


                            </CodeTypeValue>


                          </div>
                        </div>


                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Storage Date </label>
                          </div>


                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp" [(ngModel)]="StartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                              <a (click)="d.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>
                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row  ">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Count</label>
                          </div>


                          <div class="col-md-5">
                            <input type="number" class="form-control" placeholder="Count"
                                   maxlength="100" />


                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row  ">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Location</label>
                          </div>


                          <div class="col-md-5">
                            <input type="text" class="form-control" placeholder="Location">



                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row ">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Next Renewal date</label>
                          </div>

                          <div class="col-md-5">
                            <div class="date-form">
                              <input class="form-control" placeholder="Date " [minDate]="minDate" [maxDate]="maxDate"
                                     name="dp" [(ngModel)]="StartDate" ngbDatepicker #d="ngbDatepicker" #DateOfBirth="ngModel" required>
                              <small class="form-text text-danger"
                                     *ngIf="(!DateOfBirth.valid && (DateOfBirth.dirty || DateOfBirth.touched) && DateOfBirth.errors.required)">(Field cannot be left blank)</small>

                              <a (click)="d.toggle()" class="nav-link-hand">
                                <span class="date-icon"><i class="far fa-calendar-alt"></i></span>

                              </a>

                            </div>


                          </div>

                        </div>


                      </div>
                    </div>
                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Executive</label>
                          </div>

                          <div class="col-md-5">
                            <CodeTypeValue CodeType="PTNT">
                            </CodeTypeValue>
                          </div>
                        </div>


                      </div>
                    </div>

                    <div class="row">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px">
                        <div class="row">
                          <div class="col-md-4 text-align-right margin-tg-auto ">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px">Witness</label>
                          </div>

                          <div class="col-md-5">
                            <CodeTypeValue CodeType="FNSTS">

                            </CodeTypeValue>
                          </div>
                        </div>


                      </div>
                    </div>



                    <div class="row ">
                      <div class="form-group col-md-12 col-xs-12 margin-bottom-5px margin-top-10">
                        <div class="row">
                          <div class="col-md-4 text-align-right">
                            <label for="diaplayName" class="font-size-12px margin-bottom-0px"><span>*</span>Details</label>
                          </div>

                          <div class="col-md-6 padding-right-0px">
                            <textarea class="form-control3 size-2 width-inherit" rows="2" placeholder="Details"></textarea>


                          </div>
                        </div>


                      </div>
                    </div>
                    <div class="row float-right">
                      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3 margin-right-10px" (click)="activeModal.close('Close click')">Cancel</button>
                      <button type="submit" [disabled]="!f.valid" *ngIf='!isRequesting' class="btn font-size-13px actions-btn-prime">Save</button>
                    </div>
                  </div>

                </form>
             
             
           
          </div>
        </div>



      </div>
      <!--<div class="modal-footer padding-top-10px padding-bottom-10px">

      <button type="button" class="btn btn-secondary font-size-13px btn-raised button-Schedule actions-btn-prime actions-btn-prime3" (click)="activeModal.close('Close click')">Cancel</button>
      <button type="submit" class="btn font-size-13px actions-btn-prime">Save</button>
    </div>-->

    </div>
  </div>
